import * as React from 'react'

import { styled } from '~/styled'

import { Image } from '../image/Image'
import { Text } from '../text/Text'

export const SideBarHeader = styled('div', {
  base: ['border-b', 'border-b-(--border)', 'p-4', 'w-full']
})

export const SideBarBody = styled('div', {
  base: ['grow', 'overflow-y-auto', 'overflow-x-hidden', 'p-4', 'w-full']
})

export const SideBarFooter = styled('div', {
  base: ['border-t', 'border-t-(--border)', 'p-4', 'w-full']
})

const StyledSideBarBrand = styled('a', {
  base: [
    'items-end',
    'text-text',
    'flex',
    'gap-4',
    'no-underline',
    'hover:no-underline',
    'focus:no-underline'
  ]
})

export const SideBarBrand =
  StyledSideBarBrand as React.ForwardRefExoticComponent<
    React.ComponentPropsWithRef<'a'> & { as?: React.ElementType }
  >

export const SideBarBrandLogo = Image

export const SideBarBrandName = styled(Text, {
  base: ['text-text', 'whitespace-nowrap']
})
